"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.collect = void 0;
const R = require("ramda");
/**
 * Collect promise results.
 */
function collect(items, iteratee) {
    return __awaiter(this, void 0, void 0, function* () {
        return R.reduce((next, item) => __awaiter(this, void 0, void 0, function* () {
            const acc = yield next;
            const result = yield iteratee(item);
            return acc.concat(result);
        }), Promise.resolve([]), items);
    });
}
exports.collect = collect;
